import { Chip } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { IAuthorization } from "../../models/authorizations";

const translationPath = "page.authorizations.execution_status.";

export const APPROVED_SITUATIONS = ["autorizado", "autorizada", "aprovado", "aprovada"];

export const DENIED_SITUATIONS = ["negado", "negada"];

interface IExecutionStatus {
  labelKey: string;
  backgroundColor: string;
  color: string;
}

const AuthorizationExecutionStatus = ({ auth }: { auth: IAuthorization }) => {
  const { t } = useTranslation();

  const [status, setStatus] = useState<IExecutionStatus | null>(null);

  const itens = auth.requestAuthorizationItens || [];

  const isApproved = APPROVED_SITUATIONS.includes(
    (auth.documentTypeCurrentSituation || "").trim().toLowerCase()
  );

  const isDenied = DENIED_SITUATIONS.includes(
    (auth.documentTypeCurrentSituation || "").trim().toLowerCase()
  );

  const notDeniedItens = itens.filter(
    (item) =>
      !(item.procedureCurrentSituation || "").toLowerCase().includes("negado")
  );

  const hasItens = notDeniedItens.length > 0;

  const hasOnlyDeniedItens = itens.length > 0 && notDeniedItens.length === 0;

  const qtyPendingExecution = notDeniedItens.reduce(
    (total, item) => total + item.qtyPendingExecution,
    0
  );

  useEffect(() => {
    if (isDenied || (isApproved && hasOnlyDeniedItens)) {
      setStatus({
        labelKey: "denied",
        backgroundColor: "#FFCDD2",
        color: "#B71C1C",
      });
      return;
    }
    if (!isApproved) {
      setStatus({
        labelKey: "in_analysis",
        backgroundColor: "#FFF59D",
        color: "#795548",
      });
      return;
    }
    if (!hasItens) {
      setStatus(null);
      return;
    }
    if (qtyPendingExecution > 0) {
      setStatus({
        labelKey: "pending_execution",
        backgroundColor: "#B3E5FC",
        color: "#01579B",
      });
      return;
    }
    setStatus({
      labelKey: "executed",
      backgroundColor: "#B9F6CA",
      color: "#1B5E20",
    });
  }, [
    isDenied,
    isApproved,
    hasOnlyDeniedItens,
    hasItens,
    qtyPendingExecution,
  ]);

  if (!status) return null;

  return (
    <Chip
      size="small"
      label={t(translationPath + status.labelKey)}
      sx={{
        backgroundColor: status.backgroundColor,
        color: status.color,
        fontWeight: "bold",
      }}
    />
  );
};

export default AuthorizationExecutionStatus;
